import { CancellationOptionsQuery } from '@website/types/graphqlOperations';
import { UseFormReturn } from 'react-hook-form';
import PriceFormat from '@website/components/utilities/PriceFormat';
import { CancellationFormValues } from './CancellationForm';

/**
 * Remaining Balance Calculation
 *
 * Shows the remaining balance, if the user cancels some (but not all) of their spaces.
 */
export function RemainingBalance({
  booking,
  watch,
}: {
  booking: CancellationOptionsQuery['booking'];
  watch: UseFormReturn<CancellationFormValues>['watch'];
}) {
  // Number of spaces
  const currentActiveSpaces = booking.spaces.filter((space) => space.active);
  const currentSpaces = currentActiveSpaces.length;
  const spacesCancelling = parseInt(watch('spaces'));
  const remainingSpaces = currentSpaces - spacesCancelling;

  if (spacesCancelling < currentSpaces) {
    const currentBalance = currentActiveSpaces.reduce((acc, space) => {
      return acc + space.guestBalance.amountZD;
    }, 0);

    const remainingBalanceZD = currentActiveSpaces
      .slice(0, remainingSpaces)
      .reduce((acc, space) => {
        return acc + space.guestBalance.amountZD;
      }, 0);

    const { currency } = booking.spaces[0].guestBalance;

    // Don't show if the remaining balance is 0 (as it's fully paid)
    if (remainingBalanceZD === 0) {
      return null;
    }

    return (
      <>
        <h6 className="mt-4">Remaining Balance</h6>

        <p>
          After cancelling {spacesCancelling} space
          {spacesCancelling > 1 ? 's' : ''}, your new balance will be{' '}
          <PriceFormat amount={remainingBalanceZD} currencyIso={currency} />{' '}
          (previously it was{' '}
          <PriceFormat amount={currentBalance} currencyIso={currency} />
          ).
        </p>
      </>
    );
  }

  return null;
}
